/* istanbul ignore file */
/**
 * Menu component theme configuration.
 */

export const menuComponentConfig = {
  menu: {
    root: {
      background: '{content.background}',
      borderColor: '{content.border.color}',
      color: '{content.color}',
      borderRadius: '{content.border.radius}',
      shadow: '{overlay.navigation.shadow}',
      transitionDuration: '{transition.duration}',
    },
    list: {
      padding: '{navigation.list.padding}',
      gap: '{navigation.list.gap}',
    },
    item: {
      focusBackground: '{greymatter.50}',
      color: '{list.option.color}',
      focusColor: '{list.option.focus.color}',
      padding: '{list.option.padding}',
      borderRadius: '{navigation.item.border.radius}',
      gap: '{navigation.item.gap}',
      icon: {
        color: '{list.option.icon.color}',
        focusColor: '{list.option.focus.color}',
      },
      focusRing: {
        shadow: 'inset {form.field.focus.ring.shadow}',
      },
    },
    submenuLabel: {
      padding: '{navigation.submenu.label.padding}',
      fontWeight: '{navigation.submenu.label.font.weight}',
      background: '{navigation.submenu.label.background}',
      color: '{navigation.submenu.label.color}',
    },
    separator: {
      borderColor: '{content.border.color}',
    },
  },
};
